import type { ConfigProviderProps } from 'antd/es/config-provider';

const timePickerConfig: ConfigProviderProps['timePicker'] = {
  suffixIcon: <i className="fb-icon--clock" />,
};

export default timePickerConfig;
